import { getProductDetails } from "Product_Detail/common/selectors";
import { AnalyticsConstants } from "Product_Detail/common/constants/analytics";
import { apiCall } from "./apiAction";
import * as actionTypes from "../types/cartActionType";

export const fetchCart = (readOnly, cartId) => (dispatch, getState) => {
	const data = { readOnly, cartId };
	const uri = "api/v2ShoppingCart/GetCart";

	dispatch(
		apiCall(
			uri,
			data,
			undefined,
			{
				method: "GET",
				credentials: "include"
			},
			{
				request: {
					type: actionTypes.FETCH_CART_REQUEST
				},
				success: {
					type: actionTypes.FETCH_CART_SUCCESS
				},
				failure: {
					type: actionTypes.FETCH_CART_FAILURE
				}
			}
		)
	);
};

export const fetchRemoveFromCart = (item) => (dispatch, getState) => {
	const data = [];
	data.push(item);
	const uri = "api/v2ShoppingCart/RemoveFromCart";

	dispatch(
		apiCall(
			uri,
			data,
			undefined,
			{
				method: "POST",
				credentials: "include"
			},
			{
				request: {
					type: actionTypes.FETCH_REMOVEFROMCART_REQUEST
				},
				success: {
					type: actionTypes.FETCH_REMOVEFROMCART_SUCCESS
				},
				failure: {
					type: actionTypes.FETCH_REMOVEFROMCART_FAILURE
				}
			}
		)
	);
};

export const fetchAddToCart = (items) => (dispatch, getState) => {
	const data = items;
	const uri = "api/v2ShoppingCart/AddToCart";

	const productName = items
		? getState().RelatedOffers.entities.priceOffers.byId[items[0].id].title
		: null;

	dispatch(
		apiCall(
			uri,
			data,
			undefined,
			{
				method: "POST",
				credentials: "include"
			},
			{
				request: {
					type: actionTypes.FETCH_ADDTOCART_REQUEST,
					meta: {
						analytics: {
							"data-eventreg": AnalyticsConstants.analytics.CrossSelling,
							"data-eventstep": AnalyticsConstants.analytics.AddToCart,
							"data-eventtitle": productName
						}
					}
				},
				success: {
					type: actionTypes.FETCH_ADDTOCART_SUCCESS
				},
				failure: {
					type: actionTypes.FETCH_ADDTOCART_FAILURE
				}
			}
		)
	);
};

export const fetchModifyCart = (item) => (dispatch, getState) => {
	const data = item;
	const uri = "api/v2ShoppingCart/ModifyCart";

	dispatch(
		apiCall(
			uri,
			data,
			undefined,
			{
				method: "POST",
				credentials: "include"
			},
			{
				request: {
					type: actionTypes.FETCH_MODIFYCART_REQUEST,
					id: data.Id
				},
				success: {
					type: actionTypes.FETCH_MODIFYCART_SUCCESS,
					id: data.Id,
					prevAmount: data.PrevAmount,
					amount: data.Amount
				},
				failure: {
					type: actionTypes.FETCH_MODIFYCART_FAILURE
				}
			}
		)
	);
};

export const setErrorMessage = (message) => ({
	type: actionTypes.SET_ERROR_MESSAGE,
	message
});
